import React, { useEffect, useState } from 'react';
import { audit } from '@/utils/api';
import { ScrollText, User } from 'lucide-react';

export default function AuditLog() {
  const [items, setItems] = useState([]);
  const [entity, setEntity] = useState('');

  useEffect(() => {
    audit.list(entity ? { entity } : {}).then(r => setItems(r.data));
  }, [entity]);

  return (
    <div className="p-6 animate-fade-in" data-testid="audit-page">
      <div className="flex items-center gap-3 mb-5">
        <div className="w-10 h-10 rounded-btn flex items-center justify-center" style={{ background: '#8A99A020' }}>
          <ScrollText size={18} style={{ color: '#5C6B72' }} />
        </div>
        <div>
          <h1 className="text-xl font-black" style={{ color: 'var(--ink)' }}>Audit Log</h1>
          <p className="text-sm" style={{ color: 'var(--muted)' }}>Every important action, with user + timestamp</p>
        </div>
      </div>

      <div className="mb-4">
        <select className="input-agency text-sm w-60" value={entity} onChange={e => setEntity(e.target.value)} data-testid="audit-filter">
          <option value="">All entities</option>
          <option value="project">Projects</option>
          <option value="client">Clients</option>
          <option value="lead">Leads</option>
          <option value="invoice">Invoices</option>
          <option value="sow">SOWs</option>
          <option value="vault">Vault</option>
          <option value="auth">Auth events</option>
        </select>
      </div>

      {items.length === 0 ? (
        <div className="card-base p-10 text-center">
          <ScrollText size={28} style={{ color: 'var(--border)', margin: '0 auto 10px' }} />
          <p className="text-sm" style={{ color: 'var(--muted)' }}>No audit events yet</p>
          <p className="text-xs mt-1" style={{ color: 'var(--muted)' }}>
            Events are recorded when you approve leads, create/update invoices, reveal vault secrets, etc.
          </p>
        </div>
      ) : (
        <div className="space-y-1" data-testid="audit-list">
          {items.map(e => (
            <div key={e.id} className="card-base p-3 flex items-start gap-3" data-testid={`audit-${e.id}`}>
              <div className="w-8 h-8 rounded-btn flex items-center justify-center flex-shrink-0" style={{ background: 'var(--bg)' }}>
                <User size={12} style={{ color: 'var(--muted)' }} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm" style={{ color: 'var(--ink)' }}>
                  <b>{e.user_email}</b> <span style={{ color: 'var(--muted)' }}>{e.action}</span> <span className="font-mono text-xs">{e.entity}</span>
                  {e.entity_id && <span className="font-mono text-xs" style={{ color: 'var(--muted)' }}> · {e.entity_id.slice(-8)}</span>}
                </p>
                {e.meta && Object.keys(e.meta).length > 0 && (
                  <p className="text-xs mt-0.5 font-mono" style={{ color: 'var(--muted)' }}>
                    {JSON.stringify(e.meta).slice(0, 180)}
                  </p>
                )}
              </div>
              <p className="text-xs flex-shrink-0" style={{ color: 'var(--muted)' }}>{new Date(e.ts).toLocaleString()}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
